import { createContext, useContext } from "react";

import type { HotelOffer } from "@/features/hotels/types/types";

export interface HotelOffersContextValue {
  readonly data: HotelOffer[];
}

export const HotelOffersContext = createContext<HotelOffersContextValue>({
  data: [],
});

export const useHotelOffersContext = () => useContext(HotelOffersContext);
